<template lang="pug">
div
    button.change-button(
      :disabled="disabled || loading"
      @click="show = true"
      v-if="showButton"
      @hide="hideModal()"
    ) Rechazar
      b-spinner(v-if="loading" class="ml-2" variant="white" small)
    SamtekModal(
      v-model="show"
      title="Rechazar OT"
      size="lg"
      confirmText="Sí"
      cancelText="No"
      :loading="loading"
      @confirm="save"
      @cancel="hideModal"
    )
      b-form-group
        label(class="client-form-inputs") Motivo de rechazo:
        b-form-textarea(
          id="comment"
          v-model="form.comentario_rechazo "
          placeholder="Ingresar comentario..."
          rows="4"
          )
      hr
      OTUploads(:ot="ot" fileNamePattern="evidencia-rechazo" :attachmentType="ARCHIVO_ADJUNTO_TIPO.EVIDENCIA")
      hr
      b-form-group
        Label(class="form-inputs") OT {{ot.ot}} pasará a Rechazado, pendiente de revisión ¿Está seguro?
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import { ARCHIVO_ADJUNTO_TIPO } from '@/utils/enums'
import OTUploads from '../OTUploads.vue'

export default {
  components: {
    OTUploads,
    SamtekModal: () => import('@/components/Common/SamtekModal.vue'), // Dynamic import to avoid circular dep issues or path issues
  },
  mixins: [LoadingButtonMixin],
  name: 'ActionRechazar',
  props: ['ot', 'disabled'],
  data() {
    return {
      show: false,
      form: {
        id: this.ot.diagnostico_detail ? this.ot.diagnostico_detail.id : null,
        orden_trabajo: this.ot.ot,
        comentario_rechazo: this.comentario_rechazo
          ? this.comentario_rechazo
          : null,
      },
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OTStore', ['statusRequest']),
    ARCHIVO_ADJUNTO_TIPO: () => ARCHIVO_ADJUNTO_TIPO,
    showButton() {
      // const partes = this.ot.solicitud_partes?.filter(
      //   (parte) => parte.estado !== 'Dropped' && parte.estado !== 'Usado'
      // ) || []
      // return partes.length === 0
      return true
    },
  },
  methods: {
    ...mapActions('OTStore', ['getOT']),
    ...mapActions('Warehouse', ['changeWarehouseState']),
    ...mapActions('Diagnosticos', ['updateDiagnoseOT']),
    hideModal() {
      this.stopLoading()
      this.show = false
    },
    async save() {
      try {
        await this.executeWithLoading(async () => {
          await this.changeWarehouseState({
            // OT02: el rechazo ya no queda firme acá; lo confirma o lo devuelve
            // un Supervisor/Administrativo desde "Revisar Rechazo".
            state: 'Rechazado por revisar',
            orden: this.ot.ot,
            user: this.user.user.id,
          })
          const response = await this.updateDiagnoseOT(this.form)
          if (response.status === 200) {
            this.$bvToast.toast('OT enviada a revisión de rechazo.', {
              variant: 'success',
            })
            // Sin esto la vista de la OT queda con el estado anterior: el panel
            // de acciones se refresca solo, pero el detalle no. Mismo patrón que
            // ActionRevisarReparacion.
            await this.getOT(this.ot.ot)
            this.$emit('changed')
          } else {
            this.$bvToast.toast(`Error al rechazar OT: ${response.data}`, {
              variant: 'danger',
            })
          }
        })
        this.hideModal()
      } catch (error) {
        console.error('Error al rechazar OT:', error)
        this.$bvToast.toast('Error al rechazar OT', {
          variant: 'danger',
        })
        this.hideModal()
      }
    },
  },
}
</script>
